module.exports = __webpack_public_path__ + "img/nfp-1.bef222e2.png";